module.exports = __webpack_public_path__ + "static/img/BGCaminhao_VP.d93c173.png";


//////////////////
// WEBPACK FOOTER
// ./static/hotpages/promo-vale-pedagio/BGCaminhao_VP.png
// module id = 1848
// module chunks = 1